import type { HandoverApartment, HandoverSpace } from '@sivan/shared';
import { useId } from 'react';
import { apartmentHref } from '../apartment/location';
import { Value } from '../master-data/Value';
import { AppLink } from '../ui/AppLink';

function Spaces({
  label,
  spaces,
}: {
  readonly label: string;
  readonly spaces: readonly HandoverSpace[];
}) {
  return (
    <div className="property__row">
      <dt>{label}</dt>
      <dd>
        {spaces.length === 0 ? (
          <span className="hint">לא הוצמד</span>
        ) : (
          <ul className="space-list">
            {spaces.map((s) => (
              <li key={`${s.structureCode}:${s.location}:${s.number}`}>
                <span className="space-list__number">
                  <Value text={s.number} />
                </span>
                {s.location !== '' && (
                  <span className="hint">
                    {' '}
                    מרתף <Value text={s.location} />
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </dd>
    </div>
  );
}

/** The main property and its secondary properties, as Master Data holds them (read-only). */
export function PropertySummary({
  projectId,
  projectName,
  apartment,
}: {
  readonly projectId: string;
  readonly projectName: string;
  readonly apartment: HandoverApartment;
}) {
  const id = useId();
  return (
    <div className="property">
      <section className="property__card" aria-labelledby={`${id}-main`}>
        <h3 id={`${id}-main`} className="property__title">
          נכס ראשי
        </h3>
        <dl className="property__grid">
          <div className="property__row property__row--wide">
            <dt>פרויקט</dt>
            <dd>{projectName}</dd>
          </div>
          <div className="property__row">
            <dt>בניין</dt>
            <dd>
              <Value text={apartment.building} />
            </dd>
          </div>
          <div className="property__row">
            <dt>קומה</dt>
            <dd>{apartment.floor === '' ? '—' : <Value text={apartment.floor} />}</dd>
          </div>
          <div className="property__row">
            <dt>דירה</dt>
            <dd>
              <Value text={apartment.apartmentNumber} />
            </dd>
          </div>
          {apartment.modelType !== null && (
            <div className="property__row">
              <dt>טיפוס</dt>
              <dd>
                <Value text={apartment.modelType} />
              </dd>
            </div>
          )}
        </dl>
        <p className="property__link">
          <AppLink to={apartmentHref(projectId, apartment.id)}>לסביבת הדירה</AppLink>
        </p>
      </section>
      <section className="property__card" aria-labelledby={`${id}-secondary`}>
        <h3 id={`${id}-secondary`} className="property__title">
          נכסים משניים
        </h3>
        <dl className="property__grid">
          <Spaces label="חניה" spaces={apartment.parking} />
          <Spaces label="מחסן" spaces={apartment.storage} />
        </dl>
        <p className="hint">מתוך נתוני האב. שינוי הצמדות נעשה בגיליון הדירות.</p>
      </section>
    </div>
  );
}
